import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root',
})
export class PageService {
 apiUrl:string = environment.apiUrl;

  constructor(private http : HttpClient){}

  public loadPageBySlug( slug:string):Observable<any>{
    return this.http.get<Page[]>(`${this.apiUrl}/api/v1/pages/slug/${slug}`);
  }

  
 
}
